// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"57171f8b","825":"43bed6ee"}[chunkId] + ".chunk.js";
};